import React from 'react'
import PropTypes from 'prop-types'
import TooltipComponent from '../utils/TooltipComponent'
import IconComponent from './IconComponent'
import ButtonComponent from './ButtonComponent'

const NextButtonComponent = ({ onClick, children, disabled }) => {
  return (
    <TooltipComponent content="Next" id="next-tooltip" placement="bottom">
      <ButtonComponent type="button" color="success mb-1" onClick={onClick} disabled={disabled}>
        <IconComponent icon="Next" height="18" /> &nbsp;&nbsp;{children}
      </ButtonComponent>
    </TooltipComponent>
  )
}

NextButtonComponent.propTypes = {
  onClick: PropTypes.func.isRequired,
  disabled: PropTypes.bool,
  children: PropTypes.node.isRequired,
}

export default NextButtonComponent
